<!--
 * @Author: 田鑫
 * @Date: 2021-10-20 16:18:27
 * @LastEditors: 田鑫
 * @LastEditTime: 2022-01-05 10:27:51
 * @Description: 医院管理
-->
<template>
  <div class="home-container">
    <div class="hx-breadcrumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>首页</el-breadcrumb-item>
        <el-breadcrumb-item>门诊预约问诊管理</el-breadcrumb-item>
        <el-breadcrumb-item>医院管理</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="hx-form-container box-shadow">
      <el-form ref="listForm" :model="listParams" label-width="120px" inline>
        <el-form-item label="医院名称：" prop="name">
          <el-input v-model="listParams.name" placeholder="请填写医院名称"></el-input>
        </el-form-item>

        <el-form-item label="">
          <el-button @click="loadTableData" type="primary">查询</el-button>
        </el-form-item>
      </el-form>

      <hx-table-result :page-info="pager" :loading="tableLoading" @page-current-change="handleCurrentChange" @page-size-change="handleSizeChange">
        <div slot="action"></div>

        <hx-table-result-col>
          <div class="wrap-table-info-display">
            <el-button @click="dialogVisible = true" type="primary">新增</el-button>
            <span class="table-info-display">
              <span>总条数：</span>
              <span class="alert-text ft16">{{ pager.total }}</span>
            </span>
          </div>
        </hx-table-result-col>

        <el-table slot="content" :data="tableData" max-height="600" border>
          <el-table-column fixed align="center" width="60" label="序号">
            <template slot-scope="scope">
              <span v-text="(pager.pageIndex > 1 ? (pager.pageIndex - 1) * pager.pageSize : 0) + scope.$index + 1"> </span>
            </template>
          </el-table-column>
          <el-table-column label="医院名称" prop="name" align="center"></el-table-column>
          <el-table-column label="医院简介" prop="description" align="center">
            <template slot-scope="scope">
              <div class="description" v-html="scope.row.description"></div>
            </template>
          </el-table-column>
          <el-table-column label="操作" prop="" align="center">
            <template slot-scope="scope">
              <el-button type="text" @click="editItem(scope.row.id)">编辑</el-button>
              <confirm-button type="text" style="margin: 0 10px" title="确认要删除该医院吗？" @confirmed="deleteItem(scope.row.id)">
                <span>删除</span>
              </confirm-button>
            </template>
          </el-table-column>
        </el-table>
      </hx-table-result>
    </div>
    <el-dialog title="" :visible.sync="dialogVisible" @close="$refs['dialogForm'].resetFields()">
      <el-form ref="dialogForm" :model="dialogForm" :rules="dialogRules">
        <el-form-item label="医院名称：" prop="name">
          <el-input v-model="dialogForm.name" placeholder="请填写医院名称" maxlength="30"></el-input>
        </el-form-item>

        <el-form-item label="医院简介：">
          <RichTextarea v-if="dialogVisible" class="wang-editor-style" v-model="dialogForm.description" />
        </el-form-item>

        <el-form-item label="" style="text-align: center">
          <el-button @click="dialogVisible = false">取消</el-button>
          <el-button @click="saveDialog('dialogForm')" type="primary" :disabled="isDisabled">保存</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      listParams: {
        name: "",
      },
      pager: {
        pageIndex: 1,
        pageSize: 15,
        total: 0,
      },
      tableLoading: false,
      tableData: [],
      dialogVisible: false,
      dialogForm: {
        name: "",
        description: "",
      },
      dialogRules: {
        name: [{ required: true, message: "请填写医院名称", trigger: "blur" }],
      },
      id: "",
      isDisabled: false,
    };
  },
  mounted() {
    this.loadTableData();
  },
  methods: {
    loadTableData() {
      this.tableLoading = true;
      const listParams = Object.assign(this.listParams, this.pager);
      this.$http({
        url: global.apiUrl + "/medical/hospital/list",
        method: "GET",
        params: listParams,
      })
        .then(res => {
          if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
            this.tableData = res.body.data.dataList;
            this.pager.total = res.body.data.total;
          }
          this.tableLoading = false;
        })
        .catch(err => {
          this.tableLoading = false;
          console.error(err);
        });
    },
    /**
     * pageIndex的change事件
     * @param val
     */
    handleCurrentChange(val) {
      this.pager.pageIndex = val;
      this.loadTableData();
    },
    /**
     * pageSize的change事件
     * @param val
     */
    handleSizeChange(val) {
      this.pager.pageSize = val;
      this.loadTableData();
    },
    /**
     * @description: 编辑医院
     * @param {*} id
     * @return {*}
     */
    editItem(id) {
      this.$http
        .get(global.apiUrl + `/medical/hospital/detail?id=${id}`)
        .then(res => {
          if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
            Object.assign(this.dialogForm, res.body.data);
            this.dialogVisible = true;
          }
        })
        .catch(err => {
          console.error(err);
        });
    },
    /**
     * @description: 删除医院
     * @param {*} id
     * @return {*}
     */
    deleteItem(id) {
      this.$http
        .delete(global.apiUrl + `/medical/hospital/delete?id=${id}`)
        .then(res => {
          if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
            this.loadTableData();
          }
        })
        .catch(err => {
          console.error(err);
        });
    },
    /**
     * @description: 保存表单
     * @param {*} name
     * @return {*}
     */
    saveDialog(name) {
      this.$refs[name].validate(valid => {
        if (valid) {
          this.isDisabled = true;
          let url = "";
          let method = "";
          if (this.dialogForm.id) {
            url += global.apiUrl + "/medical/hospital/edit";
            method += "PUT";
          } else {
            url += global.apiUrl + "/medical/hospital/save";
            method += "POST";
          }
          this.$http({
            url: url,
            method: method,
            body: this.dialogForm,
          })
            .then(res => {
              if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
                this.dialogVisible = false;
                this.isDisabled = false;
                this.dialogForm = this.$options.data().dialogForm;
                this.loadTableData();
              } else {
                this.isDisabled = false;
              }
            })
            .catch(err => {
              console.error(err);
              this.isDisabled = false;
            });
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.wang-editor-style {
  margin-top: 10px;
}
.description {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
}
</style>
